var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChurch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0651855,
    width: 24,
    height: 24,
    fill: "url(#pattern0_1501_266)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1501_266",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1501_266",
    transform: "scale(0.0333333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1501_266",
    width: 30,
    height: 30,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAABLUlEQVR4nO2VvUoDURCFbylYBGwEUeJMoa8QRGYirIX4BnkNi7Uwc1q71L5G8iJpJHX8QVNq7w93XaLg/mW9riB7YNgLd/Z8nNnLXeda/ZV2DrDFavf+2agXK85Z8cZi8U/BK3mx2CxtnhX1dRU9XyG8EiWNabkMdRVrpLhktRdWeyW1q83js/U6Xqt9M8H0q+FHIkxDnIlMcRR3SO36GzStZC+KO66uOGc8JDbKgy7hYqMqXpnKa2axhzIwCx6Dg0nxXJpY7Sk4mMUmpYkV4+Dg3aOLfVJbFKRd0CH2goK5PzwlwV2Fw3XLMjwJBiZvWD7mNDluwiXWatCi91wLrj1qf2dn3du/O2qbb/ew4cuvmwMLBss9waA5cPT5F/LrxsCu4J0WzFVH3erf6R0kGk6B041zcAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch);
export default __webpack_public_path__ + "static/media/church.5969c30f6863e19fe6e439e8f87b50d2.svg";
export { ForwardRef as ReactComponent };